// Utility functions for cart management

export const getCart = () => {
  try {
    const savedCart = localStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : [];
  } catch (error) {
    console.error("Error getting cart:", error);
    return [];
  }
};

export const getCartCount = () => {
  const cart = getCart();
  return cart.length;
};

export const getCartTotal = () => {
  const cart = getCart();
  return cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
};

export const addToCart = (product, quantity = 1) => {
  try {
    const cart = getCart();
    const existingItemIndex = cart.findIndex((item) => item.id === product.id);

    if (existingItemIndex >= 0) {
      const newQuantity = cart[existingItemIndex].quantity + quantity;
      if (newQuantity <= product.qtyAvailable) {
        cart[existingItemIndex].quantity = newQuantity;
      } else {
        cart[existingItemIndex].quantity = product.qtyAvailable;
        saveCart(cart);
        return {
          success: false,
          message: `Only ${product.qtyAvailable} units available in total.`,
        };
      }
    } else {
      const finalQty = Math.min(quantity, product.qtyAvailable);
      cart.push({
        id: product.id,
        name: product.name,
        category: product.category,
        price: product.price,
        unit: product.unit,
        image: product.images ? product.images[0] : (product.image || ""),
        qtyAvailable: product.qtyAvailable,
        quantity: finalQty,
        slug: product.slug
      });

      if (quantity > product.qtyAvailable) {
        saveCart(cart);
        return {
          success: false,
          message: `Only ${product.qtyAvailable} units available. Adjusted quantity.`,
        };
      }
    }

    saveCart(cart);
    return { success: true, message: "Added to cart successfully!" };
  } catch (error) {
    console.error("Error adding to cart:", error);
    return { success: false, message: "Failed to add to cart" };
  }
};

export const updateQuantity = (productId, newQuantity) => {
  try {
    const cart = getCart();
    const itemIndex = cart.findIndex((item) => item.id === productId);

    if (itemIndex === -1) return { success: false, message: "Item not found" };

    const item = cart[itemIndex];
    if (newQuantity < 1) {
      removeFromCart(productId);
      return { success: true, message: "Item removed" };
    }

    if (newQuantity <= item.qtyAvailable) {
      cart[itemIndex].quantity = newQuantity;
      saveCart(cart);
      return { success: true };
    } else {
      cart[itemIndex].quantity = item.qtyAvailable;
      saveCart(cart);
      return {
        success: false,
        message: `Maximum available quantity is ${item.qtyAvailable}`,
      };
    }
  } catch (error) {
    console.error("Error updating quantity:", error);
    return { success: false, message: "Error updating quantity" };
  }
};

export const removeFromCart = (productId) => {
  try {
    let cart = getCart();
    cart = cart.filter((item) => item.id !== productId);
    saveCart(cart);
  } catch (error) {
    console.error("Error removing from cart:", error);
  }
};

export const clearCart = () => {
  localStorage.removeItem("cart");
  window.dispatchEvent(new Event("cartUpdated"));
};

const saveCart = (cart) => {
  localStorage.setItem("cart", JSON.stringify(cart));
  window.dispatchEvent(new Event("cartUpdated"));
};